import { createModel } from '@/store/tools';

const model = {
    namespace: 'baseset_slide',
    build: (T, A, S, R) => ({
        actiontypes: {
            'getStateList': T('getStateList'),
            'getTableSource': T('getTableSource'),

            'getPutStateList': T('getPutStateList'),
            'getAdTableSource': T('getAdTableSource'),

            'getDetail': T('getDetail'),
        },
        actions: {
            'getStateList': A('getStateList'),
            'getTableSource': A('getTableSource'),

            'getPutStateList': A('getPutStateList'),
            'getAdTableSource': A('getAdTableSource'),

            'getDetail': A('getDetail'),
        },
        sagas: {
            'getStateList': S('getStateList', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getTableSource': S('getTableSource', '/?cmd=com.xqxc.api.pig.mis.biz.platform.ad.AdvertSpaceMisService.listAdSpaceByLike'),

            'getPutStateList': S('getPutStateList', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getAdTableSource': S('getAdTableSource', '/?cmd=com.xqxc.api.pig.mis.biz.platform.ad.AdvertPageMisService.list'),

            'getDetail': S('getDetail', '/ad/detail'),
        },
        reducers: {
            'stateList': R('getStateList', []),
            'tableSource': R('getTableSource', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),

            'putStateList': R('getPutStateList', []),
            'adTableSource': R('getAdTableSource', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),

            'detail': R('getDetail', {}),
        }
    })
};
export default createModel(model);